import { Content, Overlay } from "@radix-ui/react-dialog";
import styled from "styled-components";

import {
  circle,
  contentShow,
  flexCenter,
  flexSpBetween,
  overlayShow,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledDialogOverlay = styled(Overlay)`
  position: fixed;
  inset: 0;
  background-color: var(--black-a9);
  animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
`;

export const StyledDialogContent = styled(Content)`
  background-color: var(--clr-white);
  border-radius: var(--border-radius-3);
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(90vw, ${rem(475)});
  max-height: 85vh;
  padding: 1.5rem;
  animation: ${contentShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 11;

  &:focus {
    outline: none;
  }

  .dialog-header {
    ${flexSpBetween}
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--clr-gray-175);

    .DialogTitle {
      margin: 0;
      font-weight: 500;
      color: var(--clr-primary-700);
      font-size: ${rem(17)};
    }

    .IconButton {
      ${flexCenter}
      ${circle(rem(28))}
      font-family: inherit;
      color: var(--clr-primary-700);

      svg {
        ${size("70%")}
        fill: var(--clr-primary-700);
      }
    }
    .IconButton:hover {
      background-color: var(--clr-primary-100);
    }
    .IconButton:focus {
      box-shadow: 0 0 0 2px var(--clr-primary-200);
    }
  }

  .DialogDescription {
    margin-top: 1.5rem;
    color: inherit;
    font-size: ${rem(14)};
    line-height: 1.3;
  }

  .dialog-footer {
    display: flex;
    margin-top: 2rem;
    justify-content: flex-end;
    padding-top: 1rem;
    border-top: 1px solid var(--clr-gray-175);
  }
`;
